import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  city: string;
  quote: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  role,
  city,
  quote,
  delay = 0
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.5
  }} className="bg-slate-800/50 p-6 rounded-2xl border border-slate-700 hover:border-amber-500/30 transition-colors relative" data-id="element-29">
      <Quote className="absolute top-6 right-6 w-8 h-8 text-slate-700" data-id="element-30" />

      <div className="flex gap-1 mb-4" data-id="element-31">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-32" />)}
      </div>

      <p className="text-slate-300 mb-6 italic leading-relaxed" data-id="element-33">"{quote}"</p>

      <div className="flex items-center gap-3" data-id="element-34">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center text-white font-bold text-sm" data-id="element-35">
          {name.charAt(0)}
        </div>
        <div data-id="element-36">
          <h4 className="text-white font-semibold text-sm" data-id="element-37">{name}</h4>
          <p className="text-slate-400 text-xs" data-id="element-38">
            {role} • {city}
          </p>
        </div>
      </div>
    </motion.div>;
}